export default "__VITE_ASSET__B1LnEf5$__"